import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWallDown"><Path fillRule="evenodd" clipRule="evenodd" d="M13 2L13 14.5858L16.25 11.3358L17.6642 12.75L12 18.4142L6.33579 12.75L7.75 11.3358L11 14.5858L11 2L13 2ZM4 20H20V22H4V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallDown;
